import { render } from "./indexCompanyComponent.vue?vue&type=template&id=07bb61d2"
import script from "./indexCompanyComponent.vue?vue&type=script&lang=js"
export * from "./indexCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__